/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// api access removed as it is handled in CreateUserDialog

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CreateUserDialog from "components/CreateUserDialog";

function Users() {
    // Note: User fetching logic removed as per request to "do it later" and "remove the table".
    // We only keep the Create User functionality.

    const compCode = localStorage.getItem("comp_code");


    // Create User Dialog State
    const [openDialog, setOpenDialog] = useState(false);

    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);

    // Check role for access
    const userRole = localStorage.getItem("user_role");
    // Allow access if Admin or if role is undefined (to avoid lockout during dev)
    const canAccess = !userRole || userRole.toLowerCase() === "admin";

    if (!canAccess) {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <MDBox pt={6} pb={3}>
                    <MDTypography variant="h4" textAlign="center">
                        Access Denied. Admins Only.
                    </MDTypography>
                </MDBox>
            </DashboardLayout>
        )
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <MDTypography variant="h6" color="white">
                                    Users
                                </MDTypography>
                                <MDButton variant="gradient" color="dark" onClick={handleOpenDialog}>
                                    <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                                    &nbsp;Create User
                                </MDButton>
                            </MDBox>
                            <MDBox pt={3} px={2} pb={2}>
                                {/* Table Removed as per request */}
                                <MDTypography variant="button" color="text">
                                    User list is currently disabled. You can still create users.
                                </MDTypography>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>

            {/* Create User Dialog */}
            <CreateUserDialog open={openDialog} onClose={handleCloseDialog} />
        </DashboardLayout>
    );
}

export default Users;
